import { configureStore } from '@reduxjs/toolkit'
import modules from 'src/store/module'

export const store = configureStore({
  reducer: {
    modules
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false
    })
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
